import type { FC } from 'react';
import styled from 'styled-components';
import type { Match, WrestlerInMatch } from '../../../types';
import {
    AvatarOpponentBoxAvatar,
    BoxSingleWrestlerContainer,
    BoxSingleWrestlerWhenThreeWrestlerOnSide,
    BoxSixWrestlersContainer,
    BoxThreeWrestlersContainer,
    BoxWhenFatalorTagMatchContainer,
    BoxWinnerGeneric,
    BoxWrestlerWhenFourOrUpperWrestlerOnSide,
    DefaultContainerCard,
    RowOpponentWhenTwoWrestlerInBox,
    TopDecorColor
} from './GenericComponentCssMatchCard';
import CenterInfoFightComponentRender, { AvatarWrestlerWhenThreeOrFourWrestlerInMatch } from './GenericComponentMatchCard';

const AvatarThreeWrestler = styled.div`
    position: relative;
    width: 75px;
    height: 75px;
    border: 2px solid rgba(163, 27, 27, 0.45);
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        border-color: rgba(163, 27, 27, 0.85);
        transform: scale(1.1);
    }

    & img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
    }

    &.right .name-wrestler {
        text-align: right;
        justify-content: flex-end;
    }
`;

const AvatarFourOrUpperWrestler = styled.div`
    position: relative;
    width: 75px;
    height: 75px;
    border: 2px solid rgba(163, 27, 27, 0.45);
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        border-color: rgba(163, 27, 27, 0.85);
        transform: scale(1.1);
    }

    & img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
    }
`;

interface HandicapMatchCardProps {
    matchInfo: Match;
    keyMatchInfo: number | string;
    navigateToWrestler: (wrestler: WrestlerInMatch) => void;
}

const HandicapMatchCard: FC<HandicapMatchCardProps> = ({ matchInfo, keyMatchInfo, navigateToWrestler }) => {
    // prendo props.match.wrestlers_by_team e lo divido in due array uguale.. se dispari, il primo array avra' un elemento in più
    const teamsWrestlers = matchInfo.wrestlers_by_team || [];
    const teamWrestlers1 = teamsWrestlers.slice(0, Math.ceil(teamsWrestlers.length / 2))[0] || [];
    const teamWrestlers2 = teamsWrestlers.slice(Math.ceil(teamsWrestlers.length / 2))[0] || [];

    // renderizza un singolo team
    const renderTeam = (teamWrestlers: WrestlerInMatch[], key: number | string, side: 'left' | 'right') => {
        switch (teamWrestlers.length) {
            case 1:
                return renderTeamOneWrestler(teamWrestlers, key, side);
            case 2:
                return renderTeamTwoWrestler(teamWrestlers, key, side);
            case 3:
                return renderTeamThreeWrestler(teamWrestlers, key, side);
            default:
                return renderTeamFourOrUpperWrestler(teamWrestlers, key, side);
        }
    };

    // Renderizzo il team che ha un sono wrestler
    const renderTeamOneWrestler = (teamWrestlers: WrestlerInMatch[], key: number | string, side: 'left' | 'right') => {
        const wrestler = teamWrestlers[0];
        console.log(wrestler);
        if (side === 'left') {
            return (
                <BoxSingleWrestlerContainer className="left-opponent-box">
                    <AvatarOpponentBoxAvatar
                    className="avatar-opponent-box-avatar"
                    width="200px" height="200px"
                    onClick={() => navigateToWrestler(wrestler)}>

                        <img src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} />
                        {wrestler.pivot.is_winner ? (
                            <BoxWinnerGeneric>
                                <span className="winner-text">WIN</span>
                                {matchInfo.win_by_dq ?
                                    <span className="by-dq">BY DQ</span>
                                : null}
                            </BoxWinnerGeneric>
                        ) : null}
                    </AvatarOpponentBoxAvatar>
                    <h2 className="wrestler-name">{wrestler.name}</h2>
                </BoxSingleWrestlerContainer>
            );
        } else {
            return (
                <BoxSingleWrestlerContainer className="right-opponent-box">
                    <h2 className="wrestler-name">{wrestler.name}</h2>
                    <AvatarOpponentBoxAvatar
                    className="avatar-opponent-box-avatar"
                    width="200px" height="200px"
                    onClick={() => navigateToWrestler(wrestler)}
                    >
                        <img src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} />
                        {wrestler.pivot.is_winner ? (

                            <BoxWinnerGeneric>
                                <span className="winner-text">WIN</span>
                                {matchInfo.win_by_dq ?
                                    <span className="by-dq">BY DQ</span>
                                : null}
                            </BoxWinnerGeneric>
                        ) : null}
                    </AvatarOpponentBoxAvatar>
                </BoxSingleWrestlerContainer>
            );
        }
    };

    // Renderizzo il team che ha due wrestler
    const renderTeamTwoWrestler = (teamWrestlers: WrestlerInMatch[], key: number | string, side: 'left' | 'right') => {
        if (side === 'left') {
            return (
                <BoxWhenFatalorTagMatchContainer className="box-team-container-left">
                    {teamWrestlers.map((wrestler, index) => (
                        <RowOpponentWhenTwoWrestlerInBox className="row-opponent row-opponent-left" key={index}>
                            <AvatarWrestlerWhenThreeOrFourWrestlerInMatch
                             wrestler={wrestler}
                             win_by_dq={matchInfo.win_by_dq}
                             navigateToWrestler={navigateToWrestler}
                            />
                            <h6 className="opponent-name">{wrestler.name}</h6>
                        </RowOpponentWhenTwoWrestlerInBox>
                    ))}
                </BoxWhenFatalorTagMatchContainer>
            );
        } else {
            return (
                <BoxWhenFatalorTagMatchContainer className="box-team-container-right">
                    {teamWrestlers.map((wrestler, index) => (
                        <RowOpponentWhenTwoWrestlerInBox className="row-opponent row-opponent-right" key={index}>
                            <h6 className="opponent-name">{wrestler.name}</h6>
                            <AvatarWrestlerWhenThreeOrFourWrestlerInMatch
                            wrestler={wrestler}
                                win_by_dq={matchInfo.win_by_dq}
                                navigateToWrestler={navigateToWrestler}
                            />
                        </RowOpponentWhenTwoWrestlerInBox>
                    ))}
                </BoxWhenFatalorTagMatchContainer>
            );
        }
    };

    // Renderizzo il team che ha tre wrestler
    const renderTeamThreeWrestler = (teamWrestlers: WrestlerInMatch[], key: number | string, side: 'left' | 'right') => {
        if (side === 'left') {
            return (
                <BoxThreeWrestlersContainer className={`box-wrestler ${side}`}>
                    {teamWrestlers.map((wrestler, index) => (
                        <BoxSingleWrestlerWhenThreeWrestlerOnSide className={`box-wrestler ${side}`} key={index}>
                            <AvatarThreeWrestler className="avatar-wrestler"
                                onClick={() => navigateToWrestler(wrestler)}
                            >
                                <img src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} />

                                {wrestler.pivot.is_winner ? (
                                    <BoxWinnerGeneric className="box-winner-generic-nwo">
                                        <span className="winner-text">WIN</span>
                                        {matchInfo.win_by_dq ?
                                            <span className="by-dq">BY DQ</span>
                                        : null}
                                    </BoxWinnerGeneric>
                                ) : null}
                            </AvatarThreeWrestler>
                            <h6 className="name-wrestler">{wrestler.name}</h6>
                        </BoxSingleWrestlerWhenThreeWrestlerOnSide>
                    ))}
                </BoxThreeWrestlersContainer>
            );
        }
        else {
            return (
                <BoxThreeWrestlersContainer className={`box-wrestler ${side}`}>
                    {teamWrestlers.map((wrestler, index) => (
                    <BoxSingleWrestlerWhenThreeWrestlerOnSide className="right"
                        onClick={() => navigateToWrestler(wrestler)}
                        key={index}
                    >
                        <h6 className="name-wrestler">{wrestler.name}</h6>

                        <AvatarThreeWrestler className={`avatar-wrestler ${side}`}
                            onClick={() => navigateToWrestler(wrestler)}
                        >
                            <img src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} />

                            {wrestler.pivot.is_winner ? (
                                <BoxWinnerGeneric className="box-winner-generic-nwo">
                                    <span className="winner-text">WIN</span>
                                    {matchInfo.win_by_dq ?
                                        <span className="by-dq">BY DQ</span>
                                    : null}
                                </BoxWinnerGeneric>
                            ) : null}
                        </AvatarThreeWrestler>


                        </BoxSingleWrestlerWhenThreeWrestlerOnSide>
                    ))}
                </BoxThreeWrestlersContainer>
            );
        }
    };

    // Renderizzo il team che ha quattro o più wrestler
    const renderTeamFourOrUpperWrestler = (teamWrestlers: WrestlerInMatch[], key: number | string, side: 'left' | 'right') => {
        if (side === 'left') {
            return (
                <BoxSixWrestlersContainer className="box-six-wrestlers-container-left">
                    {teamWrestlers.map((wrestler, idx) => (
                        <BoxWrestlerWhenFourOrUpperWrestlerOnSide className={`box-wrestler ${side}`} key={idx}>
                            <AvatarFourOrUpperWrestler className="avatar-wrestler"
                                onClick={() => navigateToWrestler(wrestler)}
                            >
                                <img src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} />
                                {wrestler.pivot.is_winner ? (
                                    <BoxWinnerGeneric className="box-winner-generic-w-100">
                                        <span className="winner-text">WIN</span>
                                        {matchInfo.win_by_dq ?
                                            <span className="by-dq">BY DQ</span>
                                        : null}
                                    </BoxWinnerGeneric>
                                ) : null}
                            </AvatarFourOrUpperWrestler>
                            <h6 className="name-wrestler">{wrestler.name}</h6>
                        </BoxWrestlerWhenFourOrUpperWrestlerOnSide>
                    ))}
                </BoxSixWrestlersContainer>
            );
        } else {
            return (
                <BoxSixWrestlersContainer className={`box-wrestler ${side}`} key={key}>
                    {teamWrestlers.map((wrestler, idx) => (
                    <BoxWrestlerWhenFourOrUpperWrestlerOnSide className={`box-wrestler ${side}`} key={idx}>
                        <h6 className="name-wrestler">{wrestler.name}</h6>
                        <AvatarFourOrUpperWrestler className="avatar-wrestler"
                            onClick={() => navigateToWrestler(wrestler)}
                        >
                            <img src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} />
                            {wrestler.pivot.is_winner ? (
                                <BoxWinnerGeneric className="box-winner-generic-w-100">
                                    <span className="winner-text">WIN</span>
                                    {matchInfo.win_by_dq ?
                                        <span className="by-dq">BY DQ</span>
                                    : null}
                                </BoxWinnerGeneric>
                            ) : null}
                        </AvatarFourOrUpperWrestler>
                    </BoxWrestlerWhenFourOrUpperWrestlerOnSide>
                    ))}
                </BoxSixWrestlersContainer>
            );
        }
    };

    //JSX
    return (
        <DefaultContainerCard>
            <TopDecorColor />

            {renderTeam(teamWrestlers1, keyMatchInfo, 'left')}

            <CenterInfoFightComponentRender nameMatch="Handicap" matchInfo={matchInfo} />

            {renderTeam(teamWrestlers2, keyMatchInfo, 'right')}
        </DefaultContainerCard>
    );
};

export default HandicapMatchCard;
